import axios from 'axios';

export async function getFormsCount(baseUrl) {
  try {
    const url = `${baseUrl}/api/v1/admin/forms/count`;
    const resp = await axios.get(url, {
      headers: { Accept: 'application/json' },
    });
    const data = resp?.data;
    const count =
      typeof data === 'number'
        ? data
        : typeof data?.total === 'number'
        ? data.total
        : data?.count ?? 0;
    return { count, error: null };
  } catch (error) {
    return { count: 0, error };
  }
}
